module.exports = __webpack_public_path__ + "img/CAL-UHF_Impulse.8217fbac.png";